import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="mt-5 pl-5 pr-5 pt-2 pb-2">
      <span>Copyright © {new Date().getFullYear()} TotalBits. All rights reserved.</span>
      <span className="reverse float-right">moc.stiblatot@ofni</span>
    </footer>
  );
}

export default Footer;
